"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardLevel = void 0;
var CardLevel = /*#__PURE__*/function (CardLevel) {
  CardLevel["FILLED"] = "filled";
  CardLevel["NONE"] = "none";
  CardLevel["OUTLINED"] = "outlined";
  CardLevel["RAISED"] = "raised";
  CardLevel["RECESSED"] = "recessed";
  return CardLevel;
}({});
exports.CardLevel = CardLevel;